export default __webpack_public_path__ + "static/media/Displacement.a3e7c1ae.mp3";